export class IapConstants {
    // static  SP_IAP_FILENAME = "iap_file";
    // static  SP_BLACKBOX = "sp_blackbox";
    // 基本属性
    static BASIC_GROUP = "basic_group";
    static BRAND = "brand";// 设备品牌
    static MODEL = "model";// 设备型号
    static OS_COUNTRY = "os_country";// 系统国家
    static OS_LANGUAGE = "os_language";// 系统语言
    static UUID = "uuid";// gaid
    static U_ID = "u_id";// uid 内部唯一id
    static SM_ID = "sm_id";// 数盟可信ID
    static TD_BLACK_BOX = "td_black_box";// 同盾blackbox
    static LOC_COUNTRY = "loc_country"; //本机国家

    // 环境属性
    static ENV_GROUP = "env_group";
    static IS_SIMULATOR = "is_simulator";// 模拟器
    static IS_DEV_MODEL = "is_dev_model";// 开发者模式
    static IS_DEBUG = "is_debug";// USB调试模式
    static IS_XPOSED = "is_xposed";// Xposed框架
    static IS_ABNORMAL_ENV = "is_abnormal_env";// 异常环境,root
    static SIM_MCC = "sim_mcc";// SIM卡运营商
    static IS_VIR_LOC = "is_vir_loc";// 虚拟定位

    // 网络属性
    static NET_GROUP = "net_group";
    static IS_VPN = "is_vpn";// SIM卡运营商
    static IS_PROXY = "is_proxy";// 网络代理
    static SSID = "ssid";//
    static MAC = "mac";//


    static PACKAGE_NAME = "package_name";// 包名
    static VERSION_CODE = "version_code";// 客户端版本号
    static PRODUCT_ID = "product_id";// 产品id 类型int
    static SCENE = "scene";// 场景【必须】客户端传入  1-注册 2-登陆 3... 类型int
    static REQ_UNIQUE = "req_unique";// 请求唯一码，避免幂等性问题；随机生成
    static EXT_FIELDS = "ext_fields";
    static USER_GROUP = "user_group";
    static THIRD_PARAM_FIELDS = "third_param_fields";
    static OS = "os";
    static H5_HOST_NAME = "h5_host_name";

    static USER_ID = "userid";
    static DATA = "data";
    static CODE = "code";

    static RESTRICT = "restrict";
    // 是否兜底配置
    static EARS_RESTRICT = 1;
    static EARS_NO_RESTRICT = 2;
    static NOT_EARS = 3;

    // iap统计相关
    static C_MR_HTTP_REQ = "c_mr_http_req";
    static C_MR_HTTP_SUCC = "c_mr_http_succ";
    static C_MR_HTTP_FAIL = "c_mr_http_fail";
    static C_MR_NET_ERROR = "c_mr_net_error";
    static C_MR_REQ = "c_mr_req";
    static C_MR_RSP = "c_mr_rsp";


    static SDK_VERSON_CODE = "sdk_verson_code";// sdk版本
    static SDK_VERSON_NAME = "sdk_verson_name";// sdk名称
    static REQ_INDEX = "req_index";// 当前请求重试次数
    static CONSUME_TIME = "consume_time";// 耗时
    static HTTP_CODE = "http_code";// 状态码
    static ERROR_CODE = "error_code";// 错误码
    static ERROR_MSG = "error_msg";// 错误消息
    static USERID = "userid";// 用户ID
    static IS_DEF = "is_def";// 是否兜底 1-采用兜底配置并被禁止  2-采用兜底配置未被禁止  3-没有采用兜底配置
    static DEF_RULE = "def_rule";// 因为什么规则被禁止，上传格式：特征组-字段-字段值=用户当前值
    // static  SM_ID = "sm_id";
    static RISK_RESULT = "risk_result";// 上传触发的风控结果
    static REQUEST_EXT = "request_ext";// 上传具体json数据
}
